
import DurationSlider from "@/components/DurationSlider";
import { useLanguage } from "@/contexts/LanguageContext";
import { Location } from "../types";

interface DurationSectionProps {
  value: number;
  onChange: (values: number[]) => void;
  selectedLocations?: Location[]; // Add selected locations prop
}

const DurationSection = ({ value, onChange, selectedLocations = [] }: DurationSectionProps) => {
  const { t, language } = useLanguage();

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border/40 p-4 sm:p-6">
      <h2 className={`text-lg sm:text-xl font-semibold text-foreground mb-4 flex items-center gap-2 ${language === 'ar' ? 'flex-row-reverse justify-start' : 'justify-start'}`}>
        <span className="text-primary">{t('campaignDuration')}</span>
      </h2>
      <DurationSlider
        value={value}
        onChange={onChange}
        selectedLocations={selectedLocations}
      />
    </div>
  );
};

export default DurationSection;
